(function () {
  const KEY = 'ri_recently_viewed_v2';
  const KEY_LEGACY = 'ri_recently_viewed_v1';

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function pillMod(platform) {
    var sys = String(platform || '').toLowerCase();
    if (sys.indexOf('64') !== -1) return 'n64';
    if (sys.indexOf('color') !== -1 || sys.indexOf('gbc') !== -1) return 'gbc';
    if (sys.indexOf('advance') !== -1 || sys.indexOf('gba') !== -1) return 'gba';
    if (sys.indexOf('gamecube') !== -1 || sys.indexOf('game cube') !== -1) return 'gamecube';
    if (sys.indexOf('3ds') !== -1) return 'nintendo';
    if (sys.indexOf('ds') !== -1) return 'ds';
    if (sys.indexOf('wii u') !== -1) return 'wiiu';
    if (sys.indexOf('wii') !== -1) return 'wii';
    if (sys.indexOf('ps5') !== -1 || sys.indexOf('playstation 5') !== -1) return 'ps5';
    if (sys.indexOf('ps4') !== -1 || sys.indexOf('playstation 4') !== -1 || sys.indexOf('psp') !== -1 || sys.indexOf('vita') !== -1) return 'ps4';
    if (sys.indexOf('ps3') !== -1 || sys.indexOf('playstation 3') !== -1) return 'ps3';
    if (sys.indexOf('ps2') !== -1 || sys.indexOf('playstation 2') !== -1) return 'ps2';
    if (sys === 'playstation' || sys === 'ps1' || sys === 'psx') return 'ps1';
    if (sys.indexOf('xbox') !== -1) return 'xbox';
    if (sys.indexOf('dreamcast') !== -1) return 'dreamcast';
    if (sys.indexOf('sega') !== -1 || sys.indexOf('genesis') !== -1 || sys.indexOf('saturn') !== -1) return 'sega';
    if (sys.indexOf('atari') !== -1) return 'atari';
    if (sys.indexOf('snes') !== -1 || sys.indexOf('super nintendo') !== -1 || sys.indexOf('super famicom') !== -1 || sys.indexOf('super nes') !== -1) return 'snes';
    if (sys.indexOf('nintendo') !== -1 || sys.indexOf('switch') !== -1 || sys.indexOf('nes') !== -1 || sys.indexOf('famicom') !== -1 || sys.indexOf('mario') !== -1) return 'nintendo';
    return 'default';
  }

  function skipSystemPart(part) {
    var d = String(part || '').toLowerCase().trim();
    if (d.indexOf('certified') !== -1) return true;
    if (d.indexOf('100-day warranty') !== -1 || d.indexOf('100 day warranty') !== -1) return true;
    if (d.indexOf('100-day coverage') !== -1 || d.indexOf('100 day coverage') !== -1) return true;
    return false;
  }

  function isSystemItem(item) {
    if (item.isGame) return false;
    return !!item.isSystem;
  }

  function parseTitle(item) {
    var title = String(item.title || '');
    var isGame = !!item.isGame;
    var isSystem = isSystemItem(item);
    var gameName = title;
    var platform = item.platform || '';
    if (isGame) {
      var parts = title.split(' - ');
      if (parts.length > 1) {
        var parsedPlat = parts[parts.length - 1];
        gameName = title.slice(0, title.length - (' - ' + parsedPlat).length);
        if (!platform) platform = item.type || parsedPlat;
      } else if (item.type) {
        platform = item.type;
      }
    } else if (isSystem) {
      var sysParts = title.split(' - ');
      var kept = [];
      for (var i = 0; i < sysParts.length; i++) {
        if (!skipSystemPart(sysParts[i])) kept.push(sysParts[i].trim());
      }
      if (kept.length) gameName = kept.join(' - ');
    }
    var nameMain = gameName;
    var edition = '';
    var open = gameName.indexOf('[');
    var close = gameName.lastIndexOf(']');
    if (open !== -1 && close > open) {
      nameMain = gameName.slice(0, open).trim();
      edition = gameName.slice(open, close + 1);
    }
    return {
      title: title,
      gameName: gameName,
      nameMain: nameMain,
      edition: edition,
      platform: platform,
      isGame: isGame,
      isSystem: isSystem
    };
  }

  function moneyHtml(item) {
    var cents = item.priceCents;
    if (cents == null && window.RIMoney && item.price) {
      cents = window.RIMoney.parseMoneyString(item.price);
    }
    if (cents == null || isNaN(cents)) {
      return item.price ? '<span class="price-item price-item--regular">' + escapeHtml(item.price) + '</span>' : '';
    }
    if (window.RIMoney && typeof window.RIMoney.formatCents === 'function') {
      return window.RIMoney.formatCents(cents, '$');
    }
    return '<span class="price-item price-item--regular">' + escapeHtml(item.price || '') + '</span>';
  }

  function imageList(item) {
    var list = [];
    if (Array.isArray(item.images)) {
      for (var i = 0; i < item.images.length && list.length < 3; i += 1) {
        if (item.images[i]) list.push(String(item.images[i]));
      }
    }
    if (!list.length && item.image) list.push(String(item.image));
    return list;
  }

  function mediaHtml(item) {
    var images = imageList(item);
    if (!images.length) {
      return '<div class="card__media ri-card-media--empty" aria-hidden="true"><div class="media media--transparent ri-card-media__blank"></div></div>';
    }
    if (images.length === 1) {
      return (
        '<div class="card__media"><div class="media media--transparent">' +
        '<img src="' +
        escapeHtml(images[0]) +
        '" alt="" loading="lazy" width="' +
        (item.imageWidth || 400) +
        '" height="' +
        (item.imageHeight || 400) +
        '">' +
        '</div></div>'
      );
    }
    var w = item.imageWidth || 400;
    var h = item.imageHeight || 400;
    var html =
      '<div class="card__media ri-card-scrub" data-ri-scrub data-ri-scrub-count="' +
      images.length +
      '" style="--ri-scrub-n: ' +
      images.length +
      '"><div class="media media--transparent ri-card-scrub__media">';
    for (var n = 0; n < images.length; n += 1) {
      if (n === 0) {
        html +=
          '<img src="' +
          escapeHtml(images[n]) +
          '" alt="" class="motion-reduce is-active" data-ri-scrub-img="0" loading="lazy" width="' + w + '" height="' + h + '">';
      } else {
        html +=
          '<img src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" data-ri-scrub-src="' +
          escapeHtml(images[n]) +
          '" alt="" class="motion-reduce" data-ri-scrub-img="' +
          n +
          '" width="' + w + '" height="' + h + '">';
      }
    }
    html += '</div><div class="ri-card-scrub__progress" aria-hidden="true">';
    for (var s = 0; s < images.length; s += 1) {
      html += '<span class="ri-card-scrub__seg' + (s === 0 ? ' is-active' : '') + '"></span>';
    }
    html += '</div></div>';
    return html;
  }

  function cardHtml(item) {
    var parsed = parseTitle(item);
    var edition = parsed.edition
      ? '<span class="ri-product-title__edition">' + escapeHtml(parsed.edition) + '</span>'
      : '';
    var pill =
      parsed.isGame && parsed.platform
        ? '<span class="ri-platform-pill ri-platform-pill--' +
          pillMod(parsed.platform) +
          ' ri-catalog-platform">' +
          escapeHtml(parsed.platform) +
          '</span>'
        : parsed.isSystem
          ? '<span class="ri-catalog-pills ri-catalog-platform">' +
            '<span class="ri-platform-pill ri-system-pill ri-system-pill--certified">Certified Tested &amp; Cleaned</span>' +
            '<span class="ri-platform-pill ri-system-pill ri-system-pill--warranty">100 Day Warranty</span>' +
            '</span>'
          : '';
    return (
      '<li class="grid__item">' +
      '<div class="card-wrapper product-card-wrapper underline-links-hover ri-catalog-card" data-ri-rv-handle="' +
      escapeHtml(item.handle || '') +
      '">' +
      '<div class="card card--card card--media">' +
      '<div class="card__inner ratio">' +
      '<a class="ri-card-media-link" href="' +
      escapeHtml(item.url) +
      '" tabindex="-1" aria-label="' +
      escapeHtml(parsed.title) +
      '">' +
      mediaHtml(item) +
      '</a>' +
      '</div>' +
      '<div class="card__content"><div class="card__information">' +
      '<div class="ri-catalog-meta">' +
      '<h3 class="card__heading h5">' +
      '<a class="full-unstyled-link" href="' +
      escapeHtml(item.url) +
      '" title="' +
      escapeHtml(parsed.title) +
      '">' +
      '<span class="ri-product-title ri-product-title--name-only"><span class="ri-product-title__name">' +
      '<span class="ri-product-title__base">' +
      escapeHtml(parsed.nameMain || parsed.title) +
      '</span>' +
      edition +
      '</span></span></a></h3>' +
      pill +
      '</div>' +
      '<div class="ri-catalog-commerce"><div class="price ri-catalog-price">' +
      moneyHtml(item) +
      '</div></div>' +
      '</div></div></div></div></li>'
    );
  }

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      if (raw) return JSON.parse(raw);
      var legacy = JSON.parse(localStorage.getItem(KEY_LEGACY) || '[]');
      return Array.isArray(legacy) ? legacy : [];
    } catch (e) {
      return [];
    }
  }

  // 40 games, not 12 (owner, 2026-10-22: the shelf ended in an empty slot). Sold-out games are kept but not shown,
  // so after a few sold-out views 12 left too few to fill a row. Same cap in snippets/ri-recently-viewed-record.
  function write(items) {
    localStorage.setItem(KEY, JSON.stringify(items.slice(0, 40)));
  }

  if (window.RIRecentlyViewedCurrent && window.RIRecentlyViewedCurrent.id) {
    var current = window.RIRecentlyViewedCurrent;
    var next = read().filter(function (item) {
      return item.id !== current.id;
    });
    next.unshift(current);
    write(next);
  }

  // Store answers by id for this page load, so a redraw only asks about newcomers.
  var checked = {};

  function render(root) {
    var grid = root.querySelector('[data-ri-recently-grid]');
    if (!grid) return;
    var max = Number(root.getAttribute('data-products-to-show')) || 5;
    var items = read();
    if (window.RIRecentlyViewedCurrent) {
      items = items.filter(function (item) {
        return item.id !== window.RIRecentlyViewedCurrent.id;
      });
    }
    // Sold-out games never show here (owner, 2026-10-22); the next game viewed takes the spot. The store's answer
    // (checkProducts) wins; before it arrives, the stock saved with the view decides.
    var soldOut = [];
    items = items.filter(function (item) {
      var known = checked[item.id] && checked[item.id].product;
      var open = known ? known.available !== false : item.available !== false;
      if (!open) soldOut.push(item);
      return open;
    });
    items = items.slice(0, max);
    if (!items.length) {
      root.hidden = true;
      root.classList.remove('ri-recently-viewed--pending');
      // Still ask about hidden sold-out games, so one back in stock returns.
      checkProducts(root, [], soldOut.slice(0, max));
      return;
    }

    root.hidden = false;
    grid.innerHTML = items.map(cardHtml).join('');
    root.classList.remove('ri-recently-viewed--pending');
    document.dispatchEvent(new CustomEvent('ri:shelf-refresh'));
    if (window.RICardScrub && typeof window.RICardScrub.scheduleInit === 'function') {
      window.RICardScrub.scheduleInit(root);
    }
    checkProducts(root, items, soldOut.slice(0, max));
    upgradeCards(root, items);
  }

  // The quick tiles above come from the few details saved when a game was viewed, so they lacked the release
  // date, genre, rating and Add to cart the collection tiles show (owner, 2026-10-22). Each game's full card
  // (sections/ri-product-card.liquid, the collection grid's card) is fetched and takes its tile's place.
  var fullCards = {};

  function fullCard(handle) {
    if (!fullCards[handle]) {
      fullCards[handle] = fetch('/products/' + encodeURIComponent(handle) + '?section_id=ri-product-card')
        .then(function (res) {
          return res.ok ? res.text() : '';
        })
        .then(function (html) {
          if (!html) return '';
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var host = doc.querySelector('[data-ri-product-card]');
          if (!host || !host.firstElementChild) return '';
          // The card prints Dawn's quick-add popup, which is never opened here (Add to cart has its own picker);
          // its hiding style loads only on collection pages, so on the homepage it showed as boxes under the
          // button (owner, 2026-10-22).
          host.querySelectorAll('quick-add-modal').forEach(function (modal) {
            modal.remove();
          });
          return host.innerHTML.trim();
        })
        .catch(function () {
          return '';
        });
    }
    return fullCards[handle];
  }

  function upgradeCards(root, items) {
    var jobs = items
      .filter(function (item) {
        return item.handle;
      })
      .map(function (item) {
        return fullCard(item.handle).then(function (html) {
          var tile = html && root.querySelector('[data-ri-rv-handle="' + item.handle + '"]');
          var li = tile && tile.closest('li');
          if (!li) return false;
          li.innerHTML = html;
          var card = li.querySelector('.card-wrapper');
          if (card) card.setAttribute('data-ri-rv-handle', item.handle);
          return true;
        });
      });
    Promise.all(jobs).then(function (done) {
      if (done.indexOf(true) === -1) return;
      document.dispatchEvent(new CustomEvent('ri:shelf-refresh'));
      if (window.RICardScrub && typeof window.RICardScrub.scheduleInit === 'function') {
        window.RICardScrub.scheduleInit(root);
      }
    });
  }

  document.querySelectorAll('.ri-recently-viewed').forEach(render);

  // Saved games can be deleted, unpublished, or renamed after they were viewed. Ask the store about each
  // card: a 404 leaves the history and the shelf redraws with the next game; a new handle updates the link.
  // hidden: saved games left off as sold out; they are asked about too, so one back in stock returns.
  function checkProducts(root, items, hidden) {
    items.forEach(function (item) {
      var card = checked[item.id] && root.querySelector('[data-ri-rv-handle="' + item.handle + '"]');
      if (card && checked[item.id].product) hydrateCover(card, checked[item.id].product);
    });
    var pending = items.concat(hidden || []).filter(function (item) {
      return item.handle && !checked[item.id];
    });
    if (!pending.length) return;
    Promise.all(
      pending.map(function (item) {
        checked[item.id] = {};
        return fetch('/products/' + encodeURIComponent(item.handle) + '.js')
          .then(function (res) {
            if (res.status === 404) return { item: item, gone: true };
            return res.ok ? res.json().then(function (product) { return { item: item, product: product }; }) : { item: item };
          })
          .catch(function () {
            return { item: item };
          });
      })
    ).then(function (results) {
      var gone = {};
      var moved = {};
      var anyGone = false;
      var anySoldOut = false;
      var anyBack = false;
      results.forEach(function (r) {
        if (r.product) checked[r.item.id].product = r.product;
        if (r.product && r.product.available === false && r.item.available !== false) anySoldOut = true;
        if (r.product && r.product.available !== false && r.item.available === false) anyBack = true;
        if (r.gone) {
          gone[r.item.id] = true;
          anyGone = true;
        } else if (r.product && r.product.handle && r.product.handle !== r.item.handle) {
          moved[r.item.id] = r.product.handle;
        }
      });
      // Stock as the store reports it now, kept with the saved game, so a sold-out game is not drawn first on
      // the next page and a restocked one comes back.
      var stock = {};
      var stockChanged = false;
      results.forEach(function (r) {
        if (!r.product) return;
        stock[r.item.id] = r.product.available !== false;
        if ((r.item.available !== false) !== stock[r.item.id]) stockChanged = true;
      });
      if (anyGone || stockChanged || Object.keys(moved).length) {
        var saved = read()
          .filter(function (item) {
            return !gone[item.id];
          })
          .map(function (item) {
            if (moved[item.id]) {
              item.handle = moved[item.id];
              item.url = '/products/' + moved[item.id];
            }
            if (Object.prototype.hasOwnProperty.call(stock, item.id)) item.available = stock[item.id];
            return item;
          });
        try {
          write(saved);
        } catch (e) {}
      }
      // A game gone or newly sold out redraws the shelf without it; one back in stock redraws it in.
      if (anyGone || anySoldOut || anyBack) {
        render(root);
        return;
      }
      results.forEach(function (r) {
        var card = root.querySelector('[data-ri-rv-handle="' + r.item.handle + '"]');
        if (!card || !r.product) return;
        if (moved[r.item.id]) {
          card.setAttribute('data-ri-rv-handle', moved[r.item.id]);
          card.querySelectorAll('a[href]').forEach(function (a) {
            a.setAttribute('href', '/products/' + moved[r.item.id]);
          });
        }
        hydrateCover(card, r.product);
      });
    });
  }

  function hydrateCover(card, product) {
    if (card.querySelector('[data-ri-scrub]')) return;
    if (!product || !Array.isArray(product.images) || product.images.length < 2) return;
    var urls = product.images.slice(0, 3).map(function (src) {
      var s = String(src || '');
      if (s.indexOf('//') === 0) return 'https:' + s;
      return s;
    });
    var inner = card.querySelector('.card__inner');
    var media = inner && inner.querySelector('.card__media');
    if (!media) return;
    var shown = media.querySelector('img');
    var holder = document.createElement('div');
    holder.innerHTML = mediaHtml({
      images: urls,
      imageWidth: shown ? Number(shown.getAttribute('width')) || shown.naturalWidth : 0,
      imageHeight: shown ? Number(shown.getAttribute('height')) || shown.naturalHeight : 0
    });
    media.replaceWith(holder.firstChild);
    if (window.RICardScrub && typeof window.RICardScrub.scheduleInit === 'function') {
      window.RICardScrub.scheduleInit(card);
    }
  }
})();
